import Marquee from "react-fast-marquee";

const ITEMS = [
  "NATO NCAGE 01GUU",
  "SAM.gov Registered Foreign Vendor",
  "UEI FJNKCGJV1QQ6",
  "OCONUS Ready",
  "EU / NATO Eastern Flank",
  "Dual-Use Technology & Logistics",
  "Enterprise IT Services",
];

export default function Ticker() {
  return (
    <div className="border-y border-slate-800 bg-[#14171A]/60 py-3.5 sm:py-5 overflow-hidden" data-testid="credentials-ticker">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="font-mono text-xs tracking-[0.25em] uppercase text-slate-500 mx-8 flex items-center gap-8"
          >
            {item}
            <span className="text-amber-500/70">&#9670;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
